function countSuggestionsInRoot(root: Document | Element): number {
  const adjacentPairs = root.querySelectorAll('del + ins');
  const standaloneIns = root.querySelectorAll('ins:not(del + ins)');
  const allDel = root.querySelectorAll('del');
  const standaloneDel = Array.from(allDel).filter((del) => del.nextElementSibling?.tagName !== 'INS');

  return adjacentPairs.length + standaloneIns.length + standaloneDel.length;
}

/** Count suggestions in an HTML string (for title or raw HTML content). */
export const countSuggestions = (htmlString: string) => {
  if (!htmlString || typeof DOMParser === 'undefined') {
    return 0;
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  return countSuggestionsInRoot(doc);
};

/** Count suggestions inside a DOM element (for rendered ReactNode body content). */
export const countSuggestionsInElement = (element: Element | null) => {
  if (!element) return 0;

  return countSuggestionsInRoot(element);
};
